import * as React from 'react';
import { useFormikContext } from 'formik';
import { useLayoutEffect } from 'react';
import { Modal } from 'antd';
import { CaretRightFilled } from '@ant-design/icons';
import { allErrors } from './allErrors';
import styled from 'styled-components';

const FormErrorsList = styled.div`
  margin-bottom: 0;
  margin-top: 12px;
  p {
    margin-bottom: 8px;
  }
`;

type ModalType = ReturnType<typeof Modal['error']>;

export interface IFormErrorsNotificationProps {}

export function FormErrorsNotification(props: IFormErrorsNotificationProps) {
  const { submitCount, errors } = useFormikContext();
  const submitCountRef = React.useRef(0);
  const modal = React.useRef<ModalType | undefined>();

  useLayoutEffect(() => {
    if (submitCount > 0 && submitCount !== submitCountRef.current) {
      submitCountRef.current = submitCount;
      if (Object.keys(errors).length > 0) {
        if (modal.current) {
          modal.current.destroy();
        }

        // console.trace('[PROC/ERR] Validation error', errors);
        modal.current = Modal.error({
          title: 'Errore di Validazione',
          width: 700,
          onOk() {
            // Fix per gestire la proprietà di `overflow: hidden` che viene
            // impostata erroneamente
            try {
              document.body.style.removeProperty('overflow');
            } catch (e: any) {}
          },
          content: (
            <FormErrorsList>
              {allErrors(errors).map((error, i) => (
                <p key={i}>
                  <CaretRightFilled /> {error}
                </p>
              ))}
            </FormErrorsList>
          )
        });
      }
    }

    return () => {
      if (modal.current) modal.current.destroy();
    };
  }, [submitCount, errors]);

  return null;
}
